var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.203 8.045c.772 0 1.297-.57 1.297-1.41V4.978a.937.937 0 00-.713-.908l-3.037-.758-.93-1.147A4.525 4.525 0 007.317.5H3.395c-.638 0-1.23.323-1.575.863l-.9 1.394A2.62 2.62 0 00.5 4.19v2.452c0 .855.555 1.41 1.35 1.41",
    stroke: "#121212",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.223 9.687a1.642 1.642 0 100-3.284 1.642 1.642 0 000 3.284zM3.5 9.687a1.642 1.642 0 10.001-3.284A1.642 1.642 0 003.5 9.687z",
    stroke: "#121212",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.853 3.313h10.905M5.54 8.045h4.927",
    stroke: "#121212",
    strokeMiterlimit: 10
  })));
}
export default SvgCarIcon;